import React, { useState, useEffect } from "react";
import {
  firestore,
  analytics,
  FieldValue,
} from "../../../components/firebase/FirebaseProvider";
import { useData } from "../../../components/firebase/DataProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  arrayToCurrencyStringKomisi,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import {
  Grid,
  Card,
  Typography,
  Button,
  CardActionArea,
  Divider,
} from "@material-ui/core";
// import Badge from "@material-ui/core/Badge";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import useStyles from "./style/produkStyle";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
import { CopyToClipboard } from "react-copy-to-clipboard";

import InfiniteScroll from "react-infinite-scroll-component";
import { useSnackbar } from "notistack";
// import { Skeleton } from "@material-ui/lab";
import { upperFirst, uniqBy } from "lodash";
// import NewFeatureIcon from "../../../assets/icon/newFeature";
import SkeletonProduct from "../../../components/atoms/SkeletonProduct";
import ScrollContainer from "react-indiana-drag-scroll";
import Gap from "../../../components/Gap";

const LIMIT = 5;
const LIMITM = 4;

const CardProduct = ({
  item,
  index,
  toDetailProduct,
  promoF,
  emptyStock,
  textBadgePromo,
  total_stok,
  productValue,
  harga_normal,
  promoFound,
  harga_str_promo,
  harga_str,
  domain,
  bagikan,
}) => {
  const classes = useStyles();
  const { level, promo, global_komisi } = useData();

  const [newArrival, setNewArrival] = useState(false);

  useEffect(() => {
    const time = new Date();
    const timeSeconds = Math.round(time.getTime() / 1000);
    const timeNewArrival = item?.new_arrival?.seconds;
    const expiredTime = timeNewArrival - timeSeconds;
    if (expiredTime > 0) {
      setNewArrival(true);
    } else {
      setNewArrival(false);
    }
  }, []);

  const lowestPrice = Math.round(Math.min(...harga_normal));

  const all_komisi_str = arrayToCurrencyStringKomisi(
    lowestPrice,
    level.level,
    promoFound,
    global_komisi,
    productValue
  );

  return (
    <div className={classes.wrapper} key={index}>
      <Card className={classes.card}>
        <CardActionArea onClick={toDetailProduct(item.id, item.nama)}>
          {promoF && !emptyStock ? (
            <div className={classes.label}>
              <Typography className={classes.txtLabel}>
                {textBadgePromo}
              </Typography>
              <Typography className={classes.txtLabel}>OFF</Typography>
            </div>
          ) : null}

          {emptyStock ? (
            <div className={classes.empty}>
              <span className={classes.txtEmpty}>Stok Habis</span>
            </div>
          ) : null}
          {item.thumbnail?.length > 0 ? (
            <div
              loading="lazy"
              // src={item.thumbnail[0]}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail[0]})`,
              }}
            />
          ) : (
            <div
              loading="lazy"
              // src={item.thumbnail}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail})`,
              }}
            />
          )}
        </CardActionArea>
        <div className={classes.contentWrapper}>
          <div
            className={classes.content}
            onClick={toDetailProduct(item.id, item.nama)}
          >
            <div style={{ display: "flex", marginBottom: 5 }}>
              {promoFound?.flash_sale || promoFound?.special_offer ? (
                <div className={classes.labelFlash}>
                  {promoFound?.flash_sale ? "Flashsale" : "Special Offer"}
                </div>
              ) : null}
              {item?.properties?.type === "preorder" && (
                <div className={classes.labelPre}>Pre Order</div>
              )}
              {newArrival && <div className={classes.labelNew}>Baru</div>}
            </div>
            <Typography className={classes.title} noWrap component="p">
              {item?.nama}
            </Typography>
            <div>
              {item?.properties?.type === "preorder" ? (
                ""
              ) : (
                <>
                  <Typography
                    className={classes.txtStockTersedia}
                    component="p"
                  >
                    Stok tersedia
                  </Typography>
                  <Typography className={classes.txtStock} component="p">
                    {total_stok > 100 ? "99+" : total_stok} pcs
                  </Typography>
                </>
              )}
            </div>
            <div>
              <Typography className={classes.txtLabelharhag} component="p">
                Harga {upperFirst(level.level)}
              </Typography>
              {promo && (
                <Typography className={classes.price} component="p">
                  {promoFound ? harga_str_promo : harga_str}
                </Typography>
              )}
            </div>
            <div className={classes.labelKomisi}>
              {all_komisi_str}{" "}
              Komisi
            </div>
            {/* {newArrival && (
              <div style={{ position: "absolute", right: 0, zIndex: "0" }}>
                <NewFeatureIcon width={32} height={32} />
              </div>
            )} */}
          </div>
          <div className={classes.btnWrap}>
            {emptyStock ? (
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="small"
                className={classes.btn}
                style={{
                  backgroundColor: "rgb(255, 107, 107)",
                }}
              >
                Stok Habis
              </Button>
            ) : (
              <CopyToClipboard
                text={`${domain}/produk/${slugify(item.nama.toLowerCase())}/${
                  item.product_id
                }`}
                onCopy={bagikan(item)}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.btn}
                  // endIcon={<ShareIcon />}
                >
                  Bagikan Produk
                </Button>
              </CopyToClipboard>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

function Produk() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [products, setProducts] = useState([]);
  const [productsKosong, setProductsKosong] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const [copied, setCopied] = useState(true);
  const lastVisible = React.useRef();
  const [productCounts, setProductCounts] = React.useState(0);
  const {
    level,
    promo,
    global_komisi,
    webstore,
    webstoreRef,
    profil,
    recomendationsCustomList,
    preorderUtils
  } = useData();
  const [filter, setFilter] = useState("sorting_number");
  const [sort, setSort] = useState("asc");
  // console.log(lastVisible.current);
  const domain = `https://${webstore.domain}.tokorame.store`;
  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  useEffect(() => {
    const productsRef = firestore.collection("products");
    async function getProducts() {
      setLoading(true);
      setProducts([]);
      lastVisible.current = 0;
      setLoadingMore(true);
      // limit 2 products in
      try {
        const query = await productsRef
          .where("sembunyikan_produk", "==", false)
          .orderBy(filter, sort)
          .limit(LIMIT)
          .get();

        const queryVisble = await productsRef
          .where("visible_users", "==", profil.id)
          .orderBy(filter, sort)
          .limit(LIMIT)
          .get();

        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.concat(queryVisble.docs).map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where(`harga_normal`, ">", 0)
                .get();
              const objProduct = {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
              return objProduct;
            })
          );

          const filteredProducts = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            const statusPO =
              product?.properties?.type === "preorder"
                ? product?.properties.end_at?.seconds * 1000 > Date.now()
                : true;
            return product.variants.length > 0 && total_stok > 0 && statusPO;
          });
          const arrUniq = uniqBy(filteredProducts, "id");
          setProducts((products) => [...products, ...arrUniq]);

          const filteredProductsKosong = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            const statusPO =
              product?.properties?.type === "preorder"
                ? product?.properties.end_at?.seconds * 1000 > Date.now()
                : true;
            return product.variants.length > 0 && total_stok <= 0 && statusPO;
          });

          setProductsKosong((productsKosong) => [
            ...productsKosong,
            ...filteredProductsKosong,
          ]);

          lastVisible.current = query.docs[query.docs.length - 1];
        } else {
          lastVisible.current = null;
          // setProducts((products) => [...products, ...productsKosong]);
        }
        firestore
          .collection("products")
          .where("sembunyikan_produk", "==", false)
          .get()
          .then(function (as) {
            setProductCounts(as.size);
          })
          .catch((e) => console.log(`Error Count Products: ${e}`));
      } catch (e) {
        console.log("err prod", e.message);
      }

      setLoading(false);
    }

    getProducts();
  }, [filter, sort]);

  const loadMoreProducts = async () => {
    if (lastVisible.current && loadingMore) {
      setLoadingMore(true);
      try {
        const productsRef = firestore.collection("products");
        const query = await productsRef
          .where("sembunyikan_produk", "==", false)
          .orderBy(filter, sort)
          .startAfter(lastVisible.current)
          .limit(LIMIT)
          .get();

        const queryVisble = await productsRef
          .where("visible_users", "==", profil.id)
          .orderBy(filter, sort)
          .startAfter(lastVisible.current)
          .limit(LIMIT)
          .get();

        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.concat(queryVisble.docs).map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where(`harga_normal`, ">", 0)
                .get();
              const objProduct = {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
              return objProduct;
            })
          );
          const filteredProducts = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            const statusPO =
              product?.properties?.type === "preorder"
                ? product?.properties.end_at?.seconds * 1000 > Date.now()
                : true;

            const visibleUser = product.visible_users == profil.id;
            return product.variants.length > 0 && total_stok > 0 && statusPO;
          });
          const arrUniq = uniqBy(filteredProducts, "id");
          setProducts((products) => [...products, ...arrUniq]);

          const filteredProductsKosong = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            const statusPO =
              product?.properties?.type === "preorder"
                ? product?.properties.end_at?.seconds * 1000 > Date.now()
                : true;

            return product.variants.length > 0 && total_stok <= 0 && statusPO;
          });

          setProductsKosong((productsKosong) => [
            ...productsKosong,
            ...filteredProductsKosong,
          ]);

          lastVisible.current = query.docs[query.docs.length - 1];
        } else {
          lastVisible.current = null;
          // setProducts((products) => [...products, ...productsKosong]);
          setLoadingMore(false);
        }
      } catch (e) {
        console.log(e);
        setLoadingMore(false);
      }
    }
  };

  const bagikan = (data) => async () => {
    setCopied(true);
    // console.log(data);
    const findProductId = webstore.products?.includes?.(data.id);
    const checkDownpayment = preorderUtils?.down_payment_products?.includes(data.id);
    const downPaymentStatus = checkDownpayment && preorderUtils?.down_payment_option;
    // console.log(findProductId);

    if (!findProductId && !downPaymentStatus) {
      await webstoreRef.set(
        {
          products: FieldValue.arrayUnion(data.id),
        },
        { merge: true }
      );
    }

    enqueueSnackbar("Link di salin", { variant: "success" });
  };

  return (
    <>
      <Gap height={20} />
      <div
        style={{
          paddingTop: "55px",
          position: "sticky",
          top: 0,
          zIndex: "99",
        }}
      >
        <Divider style={{ height: 5, marginLeft: -10, marginRight: -10 }} />
        <ScrollContainer
          style={{
            display: "flex",
            // overflowX: "auto",
            overflow: "auto",
            flexWrap: "nowrap",
            paddingTop: 5,
            // PaddingTop: "15px",
            backgroundColor: "white",
            // justifyContent: "space-around",
            // marginLeft: "10px",
          }}
        >
          {" "}
          <div style={{ width: "100%", paddingRight: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("sorting_number");
                setSort("asc");
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                {recomendationsCustomList?.custom_fields?.recommendation?.custom
                  ? recomendationsCustomList?.custom_fields?.recommendation
                      ?.custom
                  : recomendationsCustomList?.custom_fields?.recommendation
                      ?.default}
              </Typography>
            </Button>
            {filter === "sorting_number" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>
          <Divider orientation="vertical" flexItem />
          <div style={{ width: "100%", paddingRight: 5, paddingLeft: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("created_at");
                setSort("desc");
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                Terbaru
              </Typography>{" "}
            </Button>
            {filter === "created_at" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>
          <Divider orientation="vertical" flexItem />
          <div style={{ width: "100%", paddingRight: 5, paddingLeft: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("sorting.bestseller");
                setSort("asc");
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                Terlaris
              </Typography>{" "}
            </Button>
            {filter === "sorting.bestseller" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>
          <Divider orientation="vertical" flexItem />
          <div style={{ width: "100%", paddingLeft: 5, paddingRight: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("sorting.views");
                setSort("asc");
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                Terpopuler
              </Typography>
            </Button>
            {filter === "sorting.views" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>{" "}
          <Divider orientation="vertical" flexItem />
          <div style={{ width: "100%", paddingLeft: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("sorting.price");
                if (sort === "asc") {
                  setSort("desc");
                } else {
                  setSort("asc");
                }
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                Harga
              </Typography>
              {filter === "sorting.price" ? (
                <>
                  {sort === "asc" ? (
                    <ArrowDownwardIcon
                      style={{ marginLeft: "5px", fontSize: 15 }}
                    />
                  ) : (
                    <ArrowUpwardIcon
                      style={{ marginLeft: "5px", fontSize: 15 }}
                    />
                  )}
                </>
              ) : (
                <ImportExportIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              )}
            </Button>
            {filter === "sorting.price" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>{" "}
          <Divider orientation="vertical" flexItem />
          <div style={{ width: "100%", paddingLeft: 5 }}>
            <Button
              fullWidth
              variant="text"
              size="small"
              onClick={() => {
                setFilter("sorting.komisi");
                if (sort === "asc") {
                  setSort("desc");
                } else {
                  setSort("asc");
                }
              }}
            >
              <Typography
                noWrap
                style={{ textTransform: "capitalize", fontSize: 13 }}
                variant="button"
              >
                Komisi
              </Typography>
              {filter === "sorting.komisi" ? (
                <>
                  {sort === "asc" ? (
                    <ArrowDownwardIcon
                      style={{ marginLeft: "5px", fontSize: 15 }}
                    />
                  ) : (
                    <ArrowUpwardIcon
                      style={{
                        marginLeft: "5px",
                        fontWeight: "bold",
                        fontSize: 15,
                      }}
                    />
                  )}
                </>
              ) : (
                <ImportExportIcon
                  fontSize="small"
                  style={{ marginLeft: "5px" }}
                />
              )}
            </Button>
            {filter === "sorting.komisi" ? (
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "#5675D3" }}
              />
            ) : null}
          </div>
        </ScrollContainer>
      </div>
      <InfiniteScroll
        dataLength={products.length + productsKosong.length}
        style={{ overflow: "hidden", marginBottom: "60px" }}
        next={loadMoreProducts}
        hasMore={loadingMore}
        loader={
          products.length < 1 ? (
            <SkeletonProduct />
          ) : (
            <Typography
              color="primary"
              style={{ textAlign: "center", marginBottom: "20px" }}
            >
              <b>Memuat</b>
            </Typography>
          )
        }
        scrollThreshold="700px"
        endMessage={
          <>
            <p style={{ textAlign: "center" }}>
              <b>Yay! Kamu Sudah Melihat Semua</b>
            </p>
          </>
        }
      >
        <div>
          <h4 style={{ marginLeft: "10px" }}>
            {productCounts} barang ditemukan
          </h4>
        </div>
        <Grid container className={classes.root} spacing={3}>
          {uniqBy(products, "id").map((item, index) => {
            const stok = item.variants.map((variant) => variant.stok_available);

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item.variants.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            const textBadgePromo = (() => {
              let text = "";

              if (promoFound) {
                if (promoFound?.tipe === "%") {
                  text = `${promoFound?.nilai}%`;
                } else {
                  text = `${promoFound?.nilai / 1000}K`;
                }
              }

              return text;
            })();

            return (
              <CardProduct
                item={item}
                index={index}
                toDetailProduct={toDetailProduct}
                textBadgePromo={textBadgePromo}
                productValue={productValue}
                harga_normal={harga_normal}
                bagikan={bagikan}
                promoFound={promoFound}
                promoF={promoF}
                harga_str_promo={harga_str_promo}
                harga_str={harga_str}
                domain={domain}
                total_stok={total_stok}
                emptyStock={emptyStock}
              />
            );
          })}
        </Grid>
      </InfiniteScroll>
    </>
  );
}

export default Produk;
